import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { Info } from '@bibliocommons/base-icons';
import { libraryShape } from '@bibliocommons/bc-prop-types';

import FormattedHTMLMessage from 'app/components/shared/FormattedHTMLMessage';

import './CommunityDisclaimer.scss';

export default function CommunityDisclaimer({ type, currentLibrary }) {
  const intl = useIntl();
  const localizedUgcType = intl.formatMessage({ id: type });
  const libraryName = currentLibrary?.get('longName') || intl.formatMessage({ id: 'library_staff' });

  return (
    <div className="cp-ugc-disclaimer">
      <span className="message-icon">
        <Info />
      </span>
      <div className="message">
        <FormattedHTMLMessage id="ugc_disclaimer_message" values={{ ugcType: localizedUgcType, libraryName }} />
      </div>
    </div>
  );
}

CommunityDisclaimer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  type: PropTypes.oneOf([
    'comments',
    'content_notices',
    'contributions',
    'lists',
    'quotations',
    'summaries',
    'community_tags',
    'videos'
  ]).isRequired
};
